import { ThemeToggle } from '@/components/theme/ThemeToggle';
import { ReactNode } from "react";

interface AuthLayoutProps {
  children: ReactNode;
  visualPanel?: ReactNode;
  mobileVisual?: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
}

export function AuthLayout({ children, visualPanel, mobileVisual, header, footer }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col lg:flex-row bg-white">
      {/* Mobile visual - top of page (< 768px) */}
      {mobileVisual && (
        <div className="md:hidden flex-shrink-0">
          {mobileVisual}
        </div>
      )}

      {/* Left column - Form content */}
      <div className="flex-1 flex flex-col min-h-screen lg:min-h-0">
        <div className="flex items-center justify-end gap-2 px-5 sm:px-8 lg:px-14 pt-5">
          <ThemeToggle />
          {header}
        </div>

        {/* Main content - centered with refined spacing */}
        <div className="flex-1 flex flex-col justify-center px-5 sm:px-8 lg:px-14 py-8">
          <div className="w-full max-w-[460px] mx-auto translate-y-0 lg:-translate-y-4">
            {children}
          </div>
        </div>

        {/* Optional footer */}
        {footer && (
          <div className="px-5 sm:px-8 lg:px-14 pb-6">
            {footer}
          </div>
        )}
      </div>

      {/* Right column - Visual panel (hidden on mobile/tablet) */}
      {visualPanel && (
        <div className="hidden lg:flex lg:w-[52%] xl:w-[55%] relative">
          {/* Subtle divider */}
          <div className="absolute left-0 top-[10%] bottom-[10%] w-px bg-gradient-to-b from-transparent via-border/50 to-transparent" />

          {/* Visual content with premium blue background */}
          <div data-theme-isolated className="flex-1 bg-gradient-to-br from-[hsl(217,91%,60%)] to-[hsl(220,85%,35%)]">
            {visualPanel}
          </div>
        </div>
      )}
    </div>
  );
}
